import { Box, Drawer, styled } from '@mui/material';
import { EditNodeForm } from './edit-node-form';
import { NodeLibrary } from './sidebar-views/node-library';
import { NodeEditModeEnum } from './edit-node-form.types';
import { getSidebarViewConfig } from './get-sidebar-view-config';
import { WorkflowSidebarControlProps } from '../workflow-editor/hooks/use-sidear-control';

export const WorkflowSidebar = ({ controller }: { controller: WorkflowSidebarControlProps }) => {
  const { isEditing, saveAction, closeAction } = getSidebarViewConfig(controller);

  return (
    <Drawer
      anchor="right"
      open={controller.open}
      onClose={controller.close}
      PaperProps={{ style: { width: 600, overflowX: 'hidden' } }}
    >
      <SlidingContainer isShifted={isEditing}>
        <ViewSection>
          <NodeLibraryWrapper>
            <NodeLibrary addDraftNode={controller.addDraftNode} />
          </NodeLibraryWrapper>
        </ViewSection>

        <ViewSection>
          <EditorWrapper>
            {(controller.view.kind === NodeEditModeEnum.EditExisting ||
              controller.view.kind === NodeEditModeEnum.EditDraft) && (
              <EditNodeForm
                mode={controller.view.kind}
                node={controller.view.node}
                onSave={saveAction}
                onClose={closeAction}
              />
            )}
          </EditorWrapper>
        </ViewSection>
      </SlidingContainer>
    </Drawer>
  );
};

const SlidingContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isShifted',
})<{ isShifted: boolean }>(({ isShifted }) => ({
  display: 'flex',
  width: '200%',
  height: '100%',
  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  transform: isShifted ? 'translateX(-50%)' : 'translateX(0%)',
}));

const NodeLibraryWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
}));

const ViewSection = styled(Box)({
  width: '50%',
  height: '100%',
  flexShrink: 0,
});

const EditorWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  padding: theme.spacing(3),
}));
